module.exports = __webpack_public_path__ + "static/media/insta-8.d3808ded.png";